import * as Yup from "yup";
import {
    dropDownErrorMsg,
    lengthErrorMsg,
    maxLengthErrorMsg,
    minLengthErrorMsg,
    ifscLengthErrorMsg
} from "../utils/constants/YupErrorMessages";
import {ascii} from "../utils/utils";

const validationSchema = Yup.object().shape({
    honorific: ascii.notOneOf(["-1"], dropDownErrorMsg).required('Honorific is required'),
    name: ascii.uppercase().required('Name is required'),
    // eslint-disable-next-line no-undef
    pan_tan: ascii.length(10, lengthErrorMsg).uppercase().required('PAN is required'),
    bank_name: ascii.notOneOf(["-1"], dropDownErrorMsg).required('Bank Name is required'),
    bank_name_other: ascii.uppercase().when('bank_name', {
        is: val => val === '999',
        then: schema => schema.required('Bank Name other is required'),
        otherwise: schema => schema.nullable()
    }),
    branch_name: ascii.uppercase().required('Branch name is required'),
    bsr_code: ascii.max(7, maxLengthErrorMsg).min(7, minLengthErrorMsg).required('BSR Code is required'),
    ifsc_code: ascii.max(11, ifscLengthErrorMsg).min(11, ifscLengthErrorMsg).required('IFSC Code is required'),
    accountant: Yup.string().notOneOf(["-1"], dropDownErrorMsg).required('Accountant is required'),
    is_ca_applicable: Yup.string().required(),
    is_bank_and_dealer_same: Yup.string().required(),
    area_code: ascii.max(3, maxLengthErrorMsg).uppercase().nullable(),
    ao_type: ascii.max(2, maxLengthErrorMsg).uppercase().nullable(),
    range_code: ascii.matches(/^\d+$/, {message: 'Range Code should be digits only', excludeEmptyString: true}).nullable(),
    ao_number: ascii.matches(/^\d+$/, {message: 'AO Number should be digits only', excludeEmptyString: true}).nullable(),
    flat_door_building: ascii.required('Flat/Foor/Building is required'),
    premise_building_village: ascii.required('Premise/Building/Village is required'),
    road_street: ascii.required('Road/Street/Block/Sector is required'),
    post_office: ascii.required('Post Office is required'),
    area_locality: ascii.required('Area/Locality is required'),
    town_city_district: ascii.required('Town/City/District is required'),
    state: ascii.notOneOf(["-1"], dropDownErrorMsg).required('State is required'),
    pincode: ascii.max(6, maxLengthErrorMsg).min(6, minLengthErrorMsg).required('Pincode is required'),
    email: ascii.email().required('Email is required'),
    // Optional, but still has to be a real address if one is typed - it is filed.
    secondary_email: ascii.email().nullable(),
    // The remitter's second number, sent as entitySecondaryMobile on 15CA Part C only.
    // Compulsory since 21 Sep 2026 at BGSS's request; the model column stays blank=True
    // so remitters saved before then still load.
    secondary_phone: ascii.max(10, maxLengthErrorMsg)
        .matches(/^\d{10}$/, {message: 'Phone Number not in correct format'})
        .required('Secondary Mobile Number is required'),
    phone: ascii.max(10, maxLengthErrorMsg).min(10, minLengthErrorMsg).required('Phone is required'),
    phone_code: ascii.nullable(),
    status: ascii.notOneOf(["-1"], dropDownErrorMsg).required('Status is required'),
    residential_status: ascii.notOneOf(["-1"], dropDownErrorMsg).required('Residential Status is required'),
    country: ascii.required('Country is required'),
    authorized_dealer_name: ascii.uppercase().when('is_bank_and_dealer_same', {
        is: val => val === 'N',
        then: schema => schema.required('Authorized Dealer Name is required'),
        otherwise: schema => schema.nullable()
    }),
    // Optional - the government form does not mark ITDREIN mandatory either.
    itdrein: ascii.uppercase().nullable(),
    place_of_business: ascii.uppercase().when('is_ca_applicable', {
        is: val => val === 'Y',
        then: schema => schema.required('Place of Business is required'),
        otherwise: schema => schema.nullable()
    }),
    // PAN of the person signing the 15CA (pcPan / userPan on Part C). Compulsory since
    // 21 Sep 2026 - only when 15CA applies, because the box is hidden otherwise.
    verification_person_pan: ascii.max(10, maxLengthErrorMsg).uppercase()
        .matches(/^[A-Z]{5}\d{4}[A-Z]$/, {message: 'PAN not in correct format', excludeEmptyString: true})
        .when('is_ca_applicable', {
            is: val => val === 'Y',
            then: schema => schema.required('Person PAN is required'),
            otherwise: schema => schema.nullable()
        }),
    verification_person_name: ascii.when('is_ca_applicable', {
        is: val => val === 'Y',
        then: schema => schema.required('Person Name is required'),
        otherwise: schema => schema.nullable()
    }),
    verification_i_we: ascii.when('is_ca_applicable', {
        is: val => val === 'Y',
        then: schema => schema.notOneOf(["-1"], dropDownErrorMsg).required('Verification I/We is required'),
        otherwise: schema => schema.nullable()
    }),
    verification_designation: ascii.when('is_ca_applicable', {
        is: val => val === 'Y',
        then: schema => schema.required('Designation is required'),
        otherwise: schema => schema.nullable()
    }),
    verification_place: ascii.when('is_ca_applicable', {
        is: val => val === 'Y', then: schema => schema.required('Place is required'), otherwise: schema => schema.nullable()
    })
});

export default validationSchema;
